<template>
    <div class="about">
        <AboutComponent />
    </div>
</template>
<script>
import AboutComponent from '@/components/about/index.vue';

export default {
    components: { AboutComponent },
};
</script>

<style lang="scss">
@import '@/public/scss/about/index.scss';
</style>
